export default __webpack_public_path__ + "static/media/Privacy.fa7fac54.png";